@import "../shared.css";

:host {
	background-color: rgb(var(--smoothly-input-background));
	display: flex;
	align-items: center;
	padding-left: var(--input-padding-side);
	box-sizing: border-box;
}
:host[show-label]>div {
	position: relative;
	padding-block: var(--input-value-padding-top) var(--input-value-padding-bottom);
}
:host>div,
:host>div>div.options {
	display: flex;
	gap: 1.5rem;
	width: 100%;
}
:host[direction=column]>div>div.options {
	flex-direction: column;
}
:host::slotted([slot=end]) {
	margin-right: 0;
	margin-left: auto;
}

:host[disabled] smoothly-input-radio-item * {
	cursor: not-allowed;
}
